import { render, staticRenderFns } from "./BodySurfaceArea.vue?vue&type=template&id=0a4d5f4a&scoped=true"
import script from "./BodySurfaceArea.vue?vue&type=script&lang=js"
export * from "./BodySurfaceArea.vue?vue&type=script&lang=js"
import style0 from "./BodySurfaceArea.vue?vue&type=style&index=0&id=0a4d5f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d5f4a",
  null
  
)

export default component.exports